import { BaseResponseHttp } from './commons.model';
import { BooleanCons, NumberCons, StringConst } from '../../constants/const';
import { IProducts } from './myActivity.model';

export class IActiveProductPending extends BaseResponseHttp {
  response?: ProductPendingActive;
}
export class IActivePackagesSent extends BaseResponseHttp {
  response?: ActivePackagesSent;
}
export class ProductPendingActive {
  totalProducts: number;
  totalPieces: number;
  items: IProducts[] = [];
  constructor() {
    this.totalProducts = NumberCons.zero;
    this.totalPieces = NumberCons.zero;
    this.items = [];
  }
}
export class ActivePackagesSent {
  orderdxpId: string;
  packages: ItemPackagesSent[];
  constructor() {
    this.packages = [];
    this.orderdxpId = StringConst.empty;
  }
}
export class ItemPackagesSent {
  numberPackage: number;
  invoiceId: number;
  status: string;
  deliveredDate: string;
  inWayDate: string;
  deliveredTo: string;
  trackingNumber: string;
  deliveryCompany: string;
  totalProducts: number;
  totalPieces: number;
  deliveryAddress: string;
  isShippingCostAccepted: boolean;
  products: IProducts[];
  imgStatus?: string;
  dateView?: string;
  legendsStatus?: string;
  listDeliveryAddres?: string[];
  isViewDeliveryCompany?: boolean;
  viewStatus?: string;
  reasonNotDelivery: string;
  nameAdvisor: string;
  phoneAdvisor: string;
  emailAdvisor: string;
  deliveryAddressId: string;
  invoiceIdLinenum: string;
  constructor() {
    this.numberPackage = NumberCons.zero;
    this.invoiceId = NumberCons.zero;
    this.status = StringConst.empty;
    this.deliveredDate = StringConst.empty;
    this.inWayDate = StringConst.empty;
    this.deliveredTo = StringConst.empty;
    this.trackingNumber = StringConst.empty;
    this.deliveryCompany = StringConst.empty;
    this.totalProducts = NumberCons.zero;
    this.totalPieces = NumberCons.zero;
    this.deliveryAddress = StringConst.empty;
    this.isShippingCostAccepted = BooleanCons.false;
    this.products = [];
    this.imgStatus = StringConst.empty;
    this.dateView = StringConst.empty;
    this.legendsStatus = StringConst.empty;
    this.listDeliveryAddres = [];
    this.isViewDeliveryCompany = false;
    this.viewStatus = StringConst.empty;
    this.reasonNotDelivery = StringConst.empty;
    this.nameAdvisor = StringConst.empty;
    this.phoneAdvisor = StringConst.empty;
    this.emailAdvisor = StringConst.empty;
    this.deliveryAddressId = StringConst.empty;
    this.invoiceIdLinenum = StringConst.empty;
  }
}

export class InvoicesOverdureStructor {
  doctorName: string;
  constructor(){
    this.doctorName = StringConst.empty;
  }
}
